import { cn } from '@/lib/utils';

export interface ConnectorBranding {
  label: string;
  color: string | null;
  initial: string;
  imageUrl?: string | null;
}

/** Small bank badge (Nubank/Itaú/Inter…) shown next to a parcelamento. */
export function ConnectorDot({
  branding,
  className,
}: {
  branding?: ConnectorBranding | null;
  className?: string;
}) {
  if (!branding) return null;
  if (branding.imageUrl) {
    return (
      <img
        src={branding.imageUrl}
        alt={branding.label}
        title={branding.label}
        className={cn('size-4 shrink-0 rounded-md object-contain', className)}
      />
    );
  }
  return (
    <span
      className={cn(
        'inline-flex size-4 shrink-0 items-center justify-center rounded-md text-3xs font-bold text-white',
        className,
      )}
      style={{ backgroundColor: branding.color ?? '#52525b' }}
      title={branding.label}
      aria-label={branding.label}
    >
      {branding.initial}
    </span>
  );
}
